module.exports = __webpack_public_path__ + "img/6.bb621ae8.jpg";